"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchOrderSizeDistribution = exports.MarketType = exports.Leverage = exports.QuoteType = exports.FeederType = exports.InstrumentCondition = exports.Status = exports.Side = void 0;
var Side;
(function (Side) {
    Side[Side["FLAT"] = 0] = "FLAT";
    Side[Side["SHORT"] = 1] = "SHORT";
    Side[Side["LONG"] = 2] = "LONG";
})(Side || (exports.Side = Side = {}));
var Status;
(function (Status) {
    Status[Status["DORMANT"] = 0] = "DORMANT";
    Status[Status["TRADING"] = 1] = "TRADING";
    Status[Status["SETTLING"] = 2] = "SETTLING";
    Status[Status["SETTLED"] = 3] = "SETTLED";
})(Status || (exports.Status = Status = {}));
var InstrumentCondition;
(function (InstrumentCondition) {
    InstrumentCondition[InstrumentCondition["NORMAL"] = 0] = "NORMAL";
    InstrumentCondition[InstrumentCondition["FROZEN"] = 1] = "FROZEN";
    InstrumentCondition[InstrumentCondition["RESOLVED"] = 2] = "RESOLVED";
})(InstrumentCondition || (exports.InstrumentCondition = InstrumentCondition = {}));
var FeederType;
(function (FeederType) {
    FeederType[FeederType["NONE_STABLE"] = 0] = "NONE_STABLE";
    FeederType[FeederType["QUOTE_STABLE"] = 1] = "QUOTE_STABLE";
    FeederType[FeederType["BASE_STABLE"] = 2] = "BASE_STABLE";
    FeederType[FeederType["BOTH_STABLE"] = 3] = "BOTH_STABLE";
})(FeederType || (exports.FeederType = FeederType = {}));
var QuoteType;
(function (QuoteType) {
    QuoteType[QuoteType["INVALID"] = 0] = "INVALID";
    QuoteType[QuoteType["STABLE"] = 1] = "STABLE";
    QuoteType[QuoteType["NONSTABLE"] = 2] = "NONSTABLE";
})(QuoteType || (exports.QuoteType = QuoteType = {}));
var Leverage;
(function (Leverage) {
    Leverage[Leverage["LOW"] = 0] = "LOW";
    Leverage[Leverage["MEDIUM"] = 1] = "MEDIUM";
    Leverage[Leverage["HIGH"] = 2] = "HIGH";
    Leverage[Leverage["RISKY"] = 3] = "RISKY";
})(Leverage || (exports.Leverage = Leverage = {}));
var MarketType;
(function (MarketType) {
    MarketType["LINK"] = "LINK";
    MarketType["DEXV2"] = "DEXV2";
    MarketType["EMG"] = "EMG";
    MarketType["PYTH"] = "PYTH";
})(MarketType || (exports.MarketType = MarketType = {}));
var BatchOrderSizeDistribution;
(function (BatchOrderSizeDistribution) {
    BatchOrderSizeDistribution[BatchOrderSizeDistribution["FLAT"] = 0] = "FLAT";
    BatchOrderSizeDistribution[BatchOrderSizeDistribution["UPPER"] = 1] = "UPPER";
    BatchOrderSizeDistribution[BatchOrderSizeDistribution["LOWER"] = 2] = "LOWER";
    BatchOrderSizeDistribution[BatchOrderSizeDistribution["RANDOM"] = 3] = "RANDOM";
})(BatchOrderSizeDistribution || (exports.BatchOrderSizeDistribution = BatchOrderSizeDistribution = {}));
